"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnouncementViewTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.AnnouncementViewTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    announcementID: typebox_1.Type.String({ format: 'uuid' }),
    profileID: typebox_1.Type.String({ format: 'uuid' }),
    viewedAt: typebox_1.Type.String({ format: 'date-time' }),
});
//# sourceMappingURL=announcement-view-transport.js.map